export { default } from "@10xjs/date-input-controller";
export * from "@10xjs/date-input-controller";
